import store from '@/store';

export default (to, from, next) => {
  const { isLoggedIn } = store.getters;

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isLoggedIn) {
      next({
        name: 'login',
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else if (isLoggedIn) {
    if (
      [
        'login',
        'register',
        'forgot-password',
        'reset-password',
        'home',
      ].indexOf(to.name) > -1
    ) {
      if (to.query && to.query.redirect) {
        next({ path: to.query.redirect });
      } else {
        next({ name: 'games' });
      }
    } else {
      next();
    }
  } else {
    next();
  }
};
